import { CmsObjectWithDefault } from '@components/Cms/types';

export type TermsAndPolicyCmsKey = 'OpenInNewTab' | 'PleaseCheckTheTerms';

export const TermsAndPolicyCmsWithDefault: CmsObjectWithDefault<TermsAndPolicyCmsKey> = {
    OpenInNewTab: {
        cmsId: 336650,
        defaultTranslation: 'Open in New Tab',
    },
    PleaseCheckTheTerms: {
        cmsId: 523111,
        defaultTranslation: 'Please check the terms before signing in or creating an account.',
    },
};
